"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var components_1 = require("@idp/duc/components");
var utils_1 = require("@idp/ui-components/utils");
var React = require("react");
var ReportingService_1 = require("../../../../api/ReportingService");
var CartUtilFunctions_1 = require("../../../../utils/CartUtilFunctions");
var UtilityFunctions_1 = require("../../../../utils/UtilityFunctions");
var WirelessTradeInState_1 = require("./WirelessTradeInState");
var styles = require("./WirelessTradeIn.scss");
var CartConfiguration_scss_1 = require("../../../CartConfigurationContainer/CartConfiguration.scss");
var ui_components_1 = require("@idp/ui-components");
var PriceContainerProps_1 = require("@idp/ui-components/components/cards/PriceContainer/PriceContainerProps");
var Api_1 = require("../../../../api/Api");
var StateProvider_1 = require("../../../../api/StateProvider");
var wlsUtils = require("../../../../utils/WirelessUtilFunctions");
var shared_offer_1 = require("@sales/shared-offer");
var ModalProps_1 = require("@idp/ui-components/components/atoms/Modal/ModalProps");
var icons = require("../../../../styles/ccc-icons-cart.scss");
var UtilityFunctions_2 = require("../../../../utils/UtilityFunctions");
var SimpleModalProps_1 = require("@idp/duc/components/containers/SimpleModal/SimpleModalProps");
var wirelessCms = wlsUtils.getWlsCmsData();
var WirelessTradeIn = /** @class */ (function (_super) {
    __extends(WirelessTradeIn, _super);
    function WirelessTradeIn(props) {
        var _this = _super.call(this, props) || this;
        _this.offerModalLegalObj = {};
        _this.state = new WirelessTradeInState_1.default();
        _this.api = new Api_1.default();
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        _this.reportingService = new ReportingService_1.default();
        _this.showTradeInExpandedView = _this.showTradeInExpandedView.bind(_this);
        _this.expandAndCollapse = _this.expandAndCollapse.bind(_this);
        _this.getTradeInSubText = _this.getTradeInSubText.bind(_this);
        _this.handleTradeInBoxClick = _this.handleTradeInBoxClick.bind(_this);
        _this.showHowTradeInWorksModal = _this.showHowTradeInWorksModal.bind(_this);
        _this.handleTradeInModal = _this.handleTradeInModal.bind(_this);
        _this.showOfferDetails = _this.showOfferDetails.bind(_this);
        _this.displaySharedOfferModal = _this.displaySharedOfferModal.bind(_this);
        _this.showSharedOfferModal = _this.showSharedOfferModal.bind(_this);
        _this.closeSharedOfferModal = _this.closeSharedOfferModal.bind(_this);
        _this.addTradeInToCart = _this.addTradeInToCart.bind(_this);
        _this.offerDecision = _this.offerDecision.bind(_this);
        _this.imeiReporting = _this.imeiReporting.bind(_this);
        _this.handleOfferLink = _this.handleOfferLink.bind(_this);
        _this.showOfferModal = _this.showOfferModal.bind(_this);
        _this.showOfferModalContent = _this.showOfferModalContent.bind(_this);
        _this.closeOfferModal = _this.closeOfferModal.bind(_this);
        _this.showCRPLaterUpgradeMessage = _this.showCRPLaterUpgradeMessage.bind(_this);
        return _this;
    }
    WirelessTradeIn.prototype.componentDidMount = function () {
        this.setState({ isTradeInDone: !!(this.props.data.hylaTradeinLineItem) });
    };
    WirelessTradeIn.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if (this.props.data && this.props.data.hylaTradeinPromotion) {
            this.isHylaRewardCard = !((_a = this.props.data.hylaTradeinPromotion) === null || _a === void 0 ? void 0 : _a.useForPriceCalculation);
        }
        else {
            this.isHylaRewardCard = this.props.data.isRewardCard;
        }
        var tradeInHeading = this.state.isTradeInDone ? wirelessCms.tradeinHeading :
            (this.isHylaRewardCard ? wirelessCms.notradeinRewardHeading :
                wirelessCms.noTradeinHeading);
        var estimatedTradeInValue = this.isHylaRewardCard ? (_d = (_c = (_b = this.props.data.hylaTradeinLineItem) === null || _b === void 0 ? void 0 : _b.price) === null || _c === void 0 ? void 0 : _c.amount) === null || _d === void 0 ? void 0 : _d.toString() : (_e = this.props.data.hylaTradeinPromotion) === null || _e === void 0 ? void 0 : _e.amount;
        estimatedTradeInValue = ((_f = Number(estimatedTradeInValue).toFixed(2)) === null || _f === void 0 ? void 0 : _f.toString()) || estimatedTradeInValue;
        var estimatedAmount = "($" + (estimatedTradeInValue === null || estimatedTradeInValue === void 0 ? void 0 : estimatedTradeInValue.toString()) + " estimated value)";
        var noTradeinSubText = wirelessCms.tradeinLegalSubHeading.replace('{0}', this.props.data.tradeinAmounts.maxPromo);
        var tradeinSubAmount = (this.props.data.tradeinAmounts.withTradeinAmt > 0) ?
            "$" + this.props.data.tradeinAmounts.withTradeinAmt + "/mo." : 'FREE';
        return (React.createElement("section", null,
            this.showCRPLaterUpgradeMessage(),
            React.createElement("div", { className: styles.panelContent },
                React.createElement("div", { className: this.state.isExpandedView ?
                        [styles.titleContainer, styles.expandedMargin].join(' ') : styles.titleContainer },
                    React.createElement("div", { className: styles.title },
                        React.createElement("div", { className: styles.titleText },
                            " ",
                            tradeInHeading,
                            " ")),
                    React.createElement("div", { onClick: this.expandAndCollapse },
                        React.createElement(components_1.Link, { "aria-label": this.state.isExpandedView ? 'Collapse Trade-in panel' : 'Expand Trade-in panel', kind: "withPrependIcon", testId: utils_1.default('Cart', tradeInHeading), 
                            // tslint:disable-next-line: jsx-no-lambda
                            onClick: function () { _this.expandAndCollapse(); }, icon: this.state.isExpandedView ?
                                React.createElement(components_1.IconSvg, { size: 16, svgNodeStr: UtilityFunctions_1.GET_ICON_SVG.UP }) :
                                React.createElement(components_1.IconSvg, { size: 16, svgNodeStr: UtilityFunctions_1.GET_ICON_SVG.DOWN }) }))),
                this.state.isTradeInDone && this.props.data.hylaTradeinLineItem && estimatedTradeInValue &&
                    React.createElement("div", { className: styles.tradeinDiv },
                        React.createElement("div", { className: styles.deviceDiv },
                            React.createElement("span", { className: styles.deviceDetails }, (_g = this.props.data.hylaTradeinLineItem) === null || _g === void 0 ? void 0 :
                                _g.displayName,
                                " ", (_k = (_j = (_h = this.props.data.
                                hylaTradeinLineItem) === null || _h === void 0 ? void 0 : _h.wirelessLineItemCharacteristics) === null || _j === void 0 ? void 0 : _j.tradeInDetail) === null || _k === void 0 ? void 0 :
                                _k._capacity),
                            "\u00A0",
                            React.createElement("span", { className: styles.deviceDetails }, estimatedAmount))),
                (!this.state.isTradeInDone || !this.props.data.hylaTradeinLineItem || !estimatedTradeInValue) &&
                    React.createElement("span", { className: styles.deviceDetails }, noTradeinSubText)),
            this.showTradeInExpandedView(estimatedTradeInValue),
            this.showHowTradeInWorksModal(),
            this.showOfferModalContent()));
    };
    WirelessTradeIn.prototype.showCRPLaterUpgradeMessage = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var crpLaterUpgradeMessageText = (_a = wirelessCms.crpLaterUpgradeMessage) === null || _a === void 0 ? void 0 : _a.replace('(0)', (_c = (_b = this.props.data.tradeinAmounts) === null || _b === void 0 ? void 0 : _b.withTradeinAmt) === null || _c === void 0 ? void 0 : _c.toString()).replace('(1)', (_e = (_d = this.props.data.tradeinAmounts) === null || _d === void 0 ? void 0 : _d.withoutTradeinAmt) === null || _e === void 0 ? void 0 : _e.toString());
        return (((_g = (_f = UtilityFunctions_1.getCartResp()) === null || _f === void 0 ? void 0 : _f.wirelessCart) === null || _g === void 0 ? void 0 : _g.crpLater) && this.props.data.hylaTradeinPromotion && ((_h = this.props.data.hylaTradeinPromotion) === null || _h === void 0 ? void 0 : _h.useForPriceCalculation) && crpLaterUpgradeMessageText &&
            (React.createElement("div", { className: styles.crpLaterUpgradeMessage },
                React.createElement("i", { className: [icons.cccIconCart, icons.cccIconCart2x,
                        icons.cccIconCartAlert, styles.alertWarnIcon].join(' '), "aria-hidden": "true" }),
                React.createElement(ui_components_1.Label, { data: { text: crpLaterUpgradeMessageText }, options: { className: styles.crpLaterUpgradeMessageText } }))));
    };
    WirelessTradeIn.prototype.handleTradeInBoxClick = function () {
        var _this = this;
        var addToCartData;
        if (this.state.isTradeInDone) {
            addToCartData =
                wlsUtils.buildTradeInRequest(this.props.data.losg, 'REMOVE', this.props.data.cartCreationSource);
            this.reportingService.fireLinkClickWithOutPageLoad(wirelessCms.noTradeinButton, CartUtilFunctions_1.getLinkClickBasekUrl());
            this.props.events.doLoading(true);
            this.api.addToCart(addToCartData).then(function (data) {
                _this.props.events.doLoading(false);
                if (data && data.content && data.content.payload && data.content.payload.wirelessCart) {
                    _this.stateManager.set('cartUpdate', { cartRefresh: true });
                    _this.stateManager.set('deviceUpdate', { deviceConfigRefresh: true });
                    _this.setState({ isTradeInDone: false });
                }
            }).catch(function (error) {
                _this.props.events.doLoading(false);
                _this.setState({ isExpandedView: false });
            });
        }
        else {
            this.setState({ isExpandedView: false });
        }
    };
    WirelessTradeIn.prototype.handleTradeInModal = function (isTradeInModalOpened) {
        if (isTradeInModalOpened) {
            this.reportingService.fireLinkClickEvent('See how trade-in works', ReportingService_1.PageUrls.TRADEIN_WORKS);
            this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.TRADEIN_WORKS);
        }
        else {
            document.querySelector('html').style.overflowY = 'scroll';
            var pageUrl = this.props.data.losg.losgType === 'NEW' ? ReportingService_1.PageUrls.CART_PAGE : ReportingService_1.PageUrls.CARTVIEW_PAGE;
            this.reportingService.firePageLoadEvent(pageUrl);
        }
        this.setState({ isTradeInModalOpened: isTradeInModalOpened });
    };
    WirelessTradeIn.prototype.handleOfferLink = function (legalAEMUrl, legalContent) {
        var _this = this;
        if (legalAEMUrl) {
            CartUtilFunctions_1.getLegalIDPData(legalAEMUrl, legalContent, legalContent.longtext, legalContent.shorttext).then(function (response) {
                if (response.longtext) {
                    legalContent.longtext = response.longtext;
                    legalContent.showLegal = true;
                    _this.showOfferModal();
                }
            }).catch(function (err) {
                legalContent.showLegal = false;
            });
        }
    };
    WirelessTradeIn.prototype.offerDecision = function (data) {
        var _this = this;
        this.setState({ sharedOfferModalDisplayed: false }, function () {
            if (!_this.checkIsImeiMode()) {
                _this.reportingService.firePageLoadEvent(CartUtilFunctions_1.getLinkClickBasekUrl());
            }
            if ((data === null || data === void 0 ? void 0 : data.status) === 'USER_ACCEPTED') {
                _this.addTradeInToCart(data);
            }
            else {
                console.log("ERROR STATUS: " + data.status);
            }
        });
    };
    WirelessTradeIn.prototype.onErrorDecision = function (data) {
        console.log("Error: " + data.errorType);
    };
    WirelessTradeIn.prototype.imeiReporting = function (data) {
        var _a, _b;
        var linkName = (data === null || data === void 0 ? void 0 : data.linkName) ? data === null || data === void 0 ? void 0 : data.linkName : 'TradeIn IMEI';
        if ((data === null || data === void 0 ? void 0 : data.eventType) === 'PAGE_LOAD_SELECT_DEVICE') {
            this.reportingService.fireLinkClickWithOutPageLoad(wirelessCms.tradeinHeading, ReportingService_1.PageUrls.TRADEIN_IMEI_SELECTION_MODAL);
            this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.TRADEIN_IMEI_SELECTION_MODAL);
        }
        else if ((data === null || data === void 0 ? void 0 : data.eventType) === 'IMEI_VALIDATION') {
            if (((_a = data === null || data === void 0 ? void 0 : data.formResponseData) === null || _a === void 0 ? void 0 : _a.statusCode) === -1) {
                this.reportingService.reportSystemEventForSelectedAction(true, '-1', linkName, ReportingService_1.EventTypesCodes.TRADEIN_IMEI_VALIDATION_SUCCESS_EVENT, ReportingService_1.PageUrls.TRADEIN_IMEI_SELECTION_MODAL, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, (_b = data === null || data === void 0 ? void 0 : data.formResponseData) === null || _b === void 0 ? void 0 : _b.statusMessage);
            }
            else {
                this.reportingService.reportSystemEventForSelectedAction(false, '0', linkName, ReportingService_1.EventTypesCodes.TRADEIN_IMEI_VALIDATION_SUCCESS_EVENT, ReportingService_1.PageUrls.TRADEIN_IMEI_SELECTION_MODAL, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, undefined);
            }
        }
        else if ((data === null || data === void 0 ? void 0 : data.eventType) === 'SKIP_IMEI_CTA_PRESSED') {
            this.reportingService.fireLinkClickWithOutPageLoad(linkName, ReportingService_1.PageUrls.TRADEIN_SKIP_IMEI, 'cart');
        }
        else if ((data === null || data === void 0 ? void 0 : data.eventType) === 'CONTINUE_IMEI_CTA_PRESSED') {
            this.reportingService.fireLinkClickWithOutPageLoad(linkName, ReportingService_1.PageUrls.TRADEIN_CONDITION_MODAL, 'cart');
        }
        else if ((data === null || data === void 0 ? void 0 : data.eventType) === 'PAGE_LOAD_ANSWER_QUESTIONS') {
            this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.TRADEIN_CONDITION_MODAL);
        }
        else {
            console.log(data === null || data === void 0 ? void 0 : data.eventType);
        }
    };
    WirelessTradeIn.prototype.checkIsImeiMode = function () {
        var _a, _b, _c, _d, _e, _f;
        if (((_b = (_a = this.props.data) === null || _a === void 0 ? void 0 : _a.losg) === null || _b === void 0 ? void 0 : _b.losgType) === 'NEW') {
            return !!(UtilityFunctions_1.getIXPFlagValue('svc-pands-pdp-tradein-imei'));
        }
        else if (((_d = (_c = this.props.data) === null || _c === void 0 ? void 0 : _c.losg) === null || _d === void 0 ? void 0 : _d.losgType) === 'AL' || ((_f = (_e = this.props.data) === null || _e === void 0 ? void 0 : _e.losg) === null || _f === void 0 ? void 0 : _f.losgType) === 'UP') {
            return !!(UtilityFunctions_1.getIXPFlagValue('svc-wsce-pdp-tradein-imei'));
        }
        else {
            return false;
        }
    };
    WirelessTradeIn.prototype.expandAndCollapse = function () {
        this.setState({ isExpandedView: !this.state.isExpandedView });
    };
    WirelessTradeIn.prototype.showTradeInExpandedView = function (estimatedTradeIn) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        var tradeInAmounts = this.props.data.tradeinAmounts;
        if (this.state.isExpandedView) {
            var tradeInText = this.isHylaRewardCard ? wirelessCms.tradeinRewardButton :
                wirelessCms.tradeinButton;
            var noTradeInText = this.isHylaRewardCard ? wirelessCms.noTradeinRewardsButton :
                wirelessCms.noTradeinButton;
            var tradeInSubText = this.getTradeInSubText();
            var tradedDeviceImageUrl = (_b = (_a = this.props.data.hylaTradeinLineItem) === null || _a === void 0 ? void 0 : _a.hardGood) === null || _b === void 0 ? void 0 : _b.productImageUrl;
            var estimatedTradeInValue = this.isHylaRewardCard ? (_e = (_d = (_c = this.props.data.hylaTradeinLineItem) === null || _c === void 0 ? void 0 : _c.price) === null || _d === void 0 ? void 0 : _d.amount) === null || _e === void 0 ? void 0 : _e.toString() : (_f = this.props.data.hylaTradeinPromotion) === null || _f === void 0 ? void 0 : _f.amount;
            estimatedTradeInValue = estimatedTradeInValue ? (_g = Number(estimatedTradeInValue).toFixed(2)) === null || _g === void 0 ? void 0 : _g.toString() :
                estimatedTradeInValue;
            var estimatedPromotionalValue = wirelessCms.tradeinEstimatedText + " $" + estimatedTradeInValue;
            var isPriceNegativeOrZero = Math.round((_h = this.props.data.tradeinAmounts) === null || _h === void 0 ? void 0 : _h.withTradeinAmt) <= 0;
            return (React.createElement(React.Fragment, null,
                !this.state.isTradeInDone &&
                    React.createElement("div", { className: styles.titleContent },
                        " ",
                        tradeInSubText,
                        " "),
                React.createElement("section", null,
                    React.createElement("div", { className: styles.tradeinBox },
                        this.state.isTradeInDone &&
                            React.createElement(components_1.CardShell, { type: "radio", isChecked: true, className: styles.boxSpace, tabIndex: 0, withSelectedBg: true },
                                React.createElement("div", { className: [styles.tradeinLineItem, styles.boxWidth].join(' ') },
                                    React.createElement("div", { className: styles.boxContent },
                                        React.createElement(ui_components_1.RichText, { testId: utils_1.default('Wireless', 'Trade In'), data: { isDecodingRequired: false, text: wirelessCms.tradeinHeading } })),
                                    !this.isHylaRewardCard &&
                                        React.createElement("div", { className: styles.tradeinPrice },
                                            !isPriceNegativeOrZero &&
                                                React.createElement(ui_components_1.PriceContainer, { testId: 'TradeIn_Price', data: { billingNote: '/mo', price: tradeInAmounts.withTradeinAmt }, options: { accessibility: "dollar " + tradeInAmounts.withTradeinAmt + " per month", decimalPoints: 2,
                                                        overrideAccessibility: true, type: PriceContainerProps_1.PricingType.XSMALL } }),
                                            isPriceNegativeOrZero &&
                                                React.createElement(ui_components_1.Label, { testId: utils_1.default('WRLS', 'Price', 'Free'), data: { text: 'FREE' }, options: { className: styles.freeItem } }))),
                                React.createElement("div", null,
                                    React.createElement("div", { className: styles.divider }),
                                    React.createElement("div", { className: styles.inlineText },
                                        React.createElement("div", { className: styles.deviceImageContainer },
                                            React.createElement("img", { src: tradedDeviceImageUrl, alt: "tradein-device-image" })),
                                        React.createElement("div", null,
                                            React.createElement("span", { className: styles.boxDisplayName }, (_j = this.props.data.hylaTradeinLineItem) === null || _j === void 0 ? void 0 : _j.displayName),
                                            React.createElement("br", null),
                                            React.createElement("span", { className: styles.boxCapacity }, (_m = (_l = (_k = this.props.data.hylaTradeinLineItem) === null || _k === void 0 ? void 0 : _k.wirelessLineItemCharacteristics) === null || _l === void 0 ? void 0 : _l.tradeInDetail) === null || _m === void 0 ? void 0 : _m._capacity),
                                            React.createElement("br", null),
                                            React.createElement("span", { className: styles.boxPromotionalValue }, estimatedPromotionalValue))),
                                    React.createElement("div", { className: styles.tradeinDetails },
                                        this.isHylaRewardCard ? wirelessCms.tradeinRewardLegal :
                                            wirelessCms.tradeinLegal.replace('{0}', (_o = tradeInAmounts.maxPromo) === null || _o === void 0 ? void 0 : _o.toString()),
                                        "\u00A0",
                                        this.showOfferDetails()))),
                        React.createElement(components_1.CardShell, { type: "radio", isChecked: false, className: styles.boxSpace, tabIndex: 0, withSelectedBg: true, 
                            // tslint:disable-next-line: jsx-no-lambda
                            onClick: function () { _this.showSharedOfferModal(); } },
                            React.createElement("div", { className: [styles.tradeinLineItem, styles.boxWidth].join(' ') },
                                React.createElement("div", { className: styles.boxContent },
                                    React.createElement(ui_components_1.RichText, { testId: utils_1.default('Wireless', 'Trade In'), data: { isDecodingRequired: false,
                                            text: this.state.isTradeInDone ?
                                                wirelessCms.tradeinDifferentDevice : tradeInText } }),
                                    "\u00A0"),
                                !this.isHylaRewardCard && !this.state.isTradeInDone &&
                                    React.createElement("div", { className: styles.tradeinPrice },
                                        !isPriceNegativeOrZero &&
                                            React.createElement(ui_components_1.PriceContainer, { testId: 'TradeIn_Price', data: { billingNote: '/mo', price: tradeInAmounts.withTradeinAmt }, options: { accessibility: "dollar " + tradeInAmounts.withTradeinAmt + " per month", decimalPoints: 2,
                                                    overrideAccessibility: true, type: PriceContainerProps_1.PricingType.XSMALL } }),
                                        isPriceNegativeOrZero &&
                                            React.createElement(ui_components_1.Label, { testId: utils_1.default('WRLS', 'Price', 'Free'), data: { text: 'FREE' }, options: { className: styles.freeItem } })))),
                        React.createElement(components_1.CardShell, { type: "radio", isChecked: this.state.isTradeInDone ? false : true, className: styles.boxSpace, tabIndex: 0, withSelectedBg: true, 
                            // tslint:disable-next-line: jsx-no-lambda
                            onClick: function () { return _this.handleTradeInBoxClick(); } },
                            React.createElement("div", { className: [styles.tradeinLineItem, styles.boxWidth].join(' ') },
                                React.createElement("div", { className: styles.boxContent },
                                    React.createElement(ui_components_1.RichText, { testId: utils_1.default('Wireless', 'Trade In'), data: { isDecodingRequired: false, text: noTradeInText } })),
                                React.createElement("div", { className: styles.tradeinPrice },
                                    React.createElement(ui_components_1.PriceContainer, { testId: 'No_TradeIn_Price', data: { billingNote: '/mo', price: tradeInAmounts.withoutTradeinAmt }, options: { accessibility: "dollar " + tradeInAmounts.withoutTradeinAmt + " per month", decimalPoints: 2,
                                            overrideAccessibility: true, type: PriceContainerProps_1.PricingType.XSMALL } })))))),
                this.displaySharedOfferModal(estimatedTradeIn)));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    WirelessTradeIn.prototype.getTradeInSubText = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement("div", { className: styles.tradeinSubHeading },
                this.isHylaRewardCard ? wirelessCms.tradeinRewardSubHeading :
                    wirelessCms.tradeinSubHeading,
                "\u00A0",
                React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('Cart', 'Link', 'TradeIn'), className: [CartConfiguration_scss_1.rennyCommonLink, styles.tradeinSubHeadingLink].join(' '), 
                    // tslint:disable-next-line: jsx-no-lambda
                    onClick: function () { _this.handleTradeInModal(true); } }, wirelessCms.tradeinSubHeadingLink))));
    };
    WirelessTradeIn.prototype.showHowTradeInWorksModal = function () {
        var _this = this;
        if (this.state.isTradeInModalOpened) {
            document.querySelector('html').style.overflow = 'hidden';
            return (React.createElement(components_1.SimpleModal, { accessibilityTitle: 'See How Trade In Detail Works', testId: "Modal_SeeOffer_Details", show: this.state.isTradeInModalOpened, 
                // tslint:disable-next-line: jsx-no-lambda
                close: function () { return _this.handleTradeInModal(false); }, fade: true, sizing: SimpleModalProps_1.SimpleModalSizing.NORMAL, size: SimpleModalProps_1.SimpleModalSize.MEDIUM, labelledbyId: "seetradeinModalheading", describedbyId: "seetradeinModaldesc" },
                React.createElement("div", { className: styles.modalDiv },
                    React.createElement("div", { id: "seetradeinModalheading", className: styles.modalHeading }, wirelessCms.tradeinModalHeading),
                    React.createElement("div", { id: "seetradeinModaldesc", className: styles.modalContent, dangerouslySetInnerHTML: { __html: wirelessCms.tradeinInfoBox } }))));
        }
        else {
            return (React.createElement(React.Fragment, null));
        }
    };
    WirelessTradeIn.prototype.showOfferDetails = function () {
        var _this = this;
        var _a, _b, _c, _d, _e;
        var promotionIdexist = false;
        var legalURL = null;
        var offers = (_a = wirelessCms.hylaTradeInOffers) === null || _a === void 0 ? void 0 : _a.offers;
        var tradeinOfferPromo = (_b = this.props.data.hylaTradeinPromotion) === null || _b === void 0 ? void 0 : _b.promotionId;
        if (tradeinOfferPromo && offers && offers.length > 0) {
            for (var _i = 0, offers_1 = offers; _i < offers_1.length; _i++) {
                var offer = offers_1[_i];
                if ((offer.promotionID === tradeinOfferPromo || offer.offerID === tradeinOfferPromo) &&
                    (((_c = offer.legalPathIDP) === null || _c === void 0 ? void 0 : _c.legalModalPath) || offer.legal)) {
                    promotionIdexist = true;
                    legalURL = ((_e = (_d = offer.legalPathIDP) === null || _d === void 0 ? void 0 : _d.legalModalPath) === null || _e === void 0 ? void 0 : _e[0]) || offer.legal;
                    break;
                }
            }
        }
        if (promotionIdexist) {
            return (React.createElement(components_1.Link, { kind: "textPlain", 
                // tslint:disable-next-line: jsx-no-lambda
                onClick: function () {
                    _this.handleOfferLink(legalURL, _this.offerModalLegalObj);
                }, testId: utils_1.default('Cart', 'Link', 'OfferDetails'), className: styles.seeOfferDetails }, this.isHylaRewardCard ? wirelessCms.tradeinRewardsSeeDetailsLink :
                wirelessCms.tradeinSeeDetailsLink));
        }
        else {
            return (React.createElement(React.Fragment, null));
        }
    };
    WirelessTradeIn.prototype.showOfferModal = function () {
        this.reportingService.fireLinkClickWithOutPageLoad(wirelessCms.tradeInSeeDetails, ReportingService_1.PageUrls.CART_BOGO_SEE_OFFER_DETAILS_MODAL);
        this.setState({ tradeInOfferModalDisplayed: true });
    };
    WirelessTradeIn.prototype.showOfferModalContent = function () {
        return (React.createElement(ui_components_1.Modal, { testId: utils_1.default('Tradein', 'Modal', 'tradeinoffers'), options: {
                center: true, className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn },
                show: this.state.tradeInOfferModalDisplayed,
                showClose: true,
                size: ModalProps_1.ModalSizes.MEDIUM,
                tabIndex: 0,
            }, events: { onClose: this.closeOfferModal } },
            React.createElement("div", { className: styles.legalContainer },
                React.createElement("p", { dangerouslySetInnerHTML: {
                        __html: this.offerModalLegalObj.longtext,
                    } }))));
    };
    WirelessTradeIn.prototype.closeOfferModal = function () {
        this.reportingService.firePageLoadEvent(CartUtilFunctions_1.getLinkClickBasekUrl());
        this.setState({ tradeInOfferModalDisplayed: false });
    };
    WirelessTradeIn.prototype.displaySharedOfferModal = function (estimatedTradein) {
        var _a, _b, _c, _d, _e, _f;
        var campaignId = UtilityFunctions_2.getCampaignSessionId();
        var deviceLineItem;
        Object.values(this.props.data.losg.lineItems).forEach(function (lineItem) {
            if (lineItem.itemType.toUpperCase() === 'DEVICE') {
                deviceLineItem = lineItem;
            }
        });
        return (React.createElement(ui_components_1.Modal, { options: {
                center: true,
                show: this.state.sharedOfferModalDisplayed,
                showClose: true,
                tabIndex: 0,
            }, events: { onClose: this.closeSharedOfferModal } },
            React.createElement("div", { className: styles.tradeinModal },
                React.createElement(shared_offer_1.SharedOffer, { data: {
                        deviceName: deviceLineItem === null || deviceLineItem === void 0 ? void 0 : deviceLineItem.displayName,
                        deviceSubType: (_b = (_a = deviceLineItem === null || deviceLineItem === void 0 ? void 0 : deviceLineItem.hardGood) === null || _a === void 0 ? void 0 : _a.wirelessHardGoodCharacteristics) === null || _b === void 0 ? void 0 : _b._deviceSubType,
                        losgTypes: this.props.data.losg.losgType,
                        productId: deviceLineItem === null || deviceLineItem === void 0 ? void 0 : deviceLineItem.offerId,
                        purchasingDeviceMSRP: this.props.data.deviceMSRP,
                        purchasingDeviceType: ((_c = deviceLineItem === null || deviceLineItem === void 0 ? void 0 : deviceLineItem._itemExtraAttributes) === null || _c === void 0 ? void 0 : _c.phone_type) === 'SMART_PHONE' ? 'phone' : deviceLineItem.productType,
                        skuId: deviceLineItem.productSKU,
                    }, losgId: (_f = (_e = (_d = this.props) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.losg) === null || _f === void 0 ? void 0 : _f.id, isImeiMode: this.checkIsImeiMode(), useWomsValidateImeiApi: (this.props.data.losg.losgType === 'NEW' ?
                        UtilityFunctions_1.getIXPFlagValue('svc-pands-enable-woms-validateimei') : UtilityFunctions_1.getIXPFlagValue('svc-wsce-enable-woms-validateimei')) || false, campaignIdHeader: (this.state.isTradeInDone && this.props.data.hylaTradeinLineItem)
                        ? campaignId : undefined, events: {
                        onAnalyticsEvent: this.imeiReporting,
                        onError: this.onErrorDecision,
                        onOfferDecision: this.offerDecision,
                    } }))));
    };
    WirelessTradeIn.prototype.closeSharedOfferModal = function () {
        this.reportingService.firePageLoadEvent(CartUtilFunctions_1.getLinkClickBasekUrl());
        this.setState({ sharedOfferModalDisplayed: false });
        sessionStorage.removeItem('validImeiData');
    };
    WirelessTradeIn.prototype.showSharedOfferModal = function () {
        if (!this.checkIsImeiMode()) {
            this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_TIERED_TRADEIN_MODAL);
        }
        this.setState({ sharedOfferModalDisplayed: true });
    };
    WirelessTradeIn.prototype.addTradeInToCart = function (modalData) {
        var _this = this;
        var addToCartData = wlsUtils.buildTradeInRequest(this.props.data.losg, 'ADD', this.props.data.cartCreationSource, true, modalData.offerCode, modalData);
        var reportingData = {
            tradeInDeviceCapacity: modalData.capacity,
            tradeInDeviceCondition: modalData.tradeInDeviceCondition,
            tradeInDeviceMake: modalData.make,
            tradeInDeviceModel: modalData.productFamily,
            tradeInFlag: modalData.isHYLAReward ? 0 : 1,
            tradeInValue: modalData.modelPrice,
        };
        this.reportingService.fireCartUpdateSubmitEvent(false, '-2', ReportingService_1.EventTypesCodes.FORM_SUBMIT_EVENT, wirelessCms.tradeinAccept, undefined, CartUtilFunctions_1.getLinkClickBasekUrl(), undefined, reportingData);
        this.props.events.doLoading(true);
        this.api.addToCart(addToCartData).then(function (data) {
            _this.props.events.doLoading(false);
            if (data && data.content && data.content.payload && data.content.payload.wirelessCart) {
                _this.reportingService.fireCartUpdateSubmitEvent(false, '0', ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, wirelessCms.tradeinAccept, undefined, CartUtilFunctions_1.getLinkClickBasekUrl(), undefined, reportingData);
                _this.stateManager.set('cartUpdate', { cartRefresh: true });
                _this.stateManager.set('deviceUpdate', { deviceConfigRefresh: true });
                _this.setState({ isTradeInDone: true });
            }
            else {
                _this.setState({ isTradeInDone: false });
                _this.reportingService.fireCartUpdateSubmitEvent(true, undefined, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, wirelessCms.tradeinAccept, JSON.stringify(data), CartUtilFunctions_1.getLinkClickBasekUrl(), undefined, reportingData);
            }
        }).catch(function (error) {
            _this.props.events.doLoading(false);
            _this.setState({ isTradeInDone: false });
            _this.reportingService.fireCartUpdateSubmitEvent(false, error && error.errorId, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, wirelessCms.tradeinAccept, JSON.stringify(error), CartUtilFunctions_1.getLinkClickBasekUrl(), undefined, reportingData);
        });
    };
    return WirelessTradeIn;
}(React.Component));
exports.default = WirelessTradeIn;
//# sourceMappingURL=WirelessTradeIn.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/WirelessCart/WirelessTradeIn/WirelessTradeIn.js
// module id = 773
// module chunks = 8